export default __webpack_public_path__ + "static/media/factoNewLogo.fa34ff04.png";